module.exports = __webpack_public_path__ + "static/media/power655.ca4b70df.png";